import React, { Component} from 'react';
import { LoginService } from 'common';
import themeService from '../themes/themeService';
import { withStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import TextField from  '../components/shared/ppbn-textfield';
import ValidatePasswordField from '../components/shared/validate-password-textfield';
import classNames from 'classnames';
import UserStorage from '../utility/UserStorage';
import clientConfig from '../clientConfig';
import WebHttpService from '../services/WebHttpService'

const { palette } = themeService.getTheme();

const loginService = new LoginService(WebHttpService,UserStorage,clientConfig)

const styles = {
    form: {
        display: 'flex',
        alignContent: 'center',
        justifyContent: 'center',
        paddingTop: '5rem',
    },
    container: {
        background: `${palette.common.gray}`,
        border: `1px solid ${palette.primary.dark}`,
        padding: '4rem',
        paddingBottom : '2rem',
        borderRadius: '3px',
        display: 'flex',
        flexDirection: 'column',
        width: '450px',        
        alignContent: 'center'
    },
    underlineBtn: {
        marginTop: '2.5rem',
        textDecoration: 'underline'
    },
    textField: {
        paddingBottom: '.75rem',        
    },
    validatePasswordField : {        
        minHeight: '120px'        
    },
    changePasswordBtn: {
        marginTop: '2.5rem',
    }
}


export class ForgotPasswordForm extends Component {    

    constructor(props) {
        super(props);

        this.state = {            
            newPassword : '',
            confirmNewPassword : '',
            verificationCode : ''
        }
    }

    confirmPasswordChange() {        
        const { newPassword, confirmNewPassword, verificationCode } = this.state;       
        const { username } = this.props;
        if(newPassword !== confirmNewPassword) {            
            this.props.alert("Passwords must match.");
        } else {
            loginService.confirmForgotPassword(username, verificationCode, newPassword, (response) => {                
                if(response && response.success) {                    
                    this.props.done({ open : true, message : "Password Changed Successfuly.", variant : "success" });
                } else {
                    this.props.done({ open : true, message : "Failed to change password.", variant : "failure" });
                }
            });
        }
    }

    render() {
        const { newPassword, confirmNewPassword, verificationCode } = this.state;
        const { classes, username } = this.props;
        const changePasswordBtnEnabled = username.length > 0 && newPassword.length > 0 && confirmNewPassword.length > 0 && verificationCode.length > 5;

        return (
            <div className={classes.form}>
                <div className={classes.container}>
                    <TextField
                        className={classNames(classes.textField, 'username')}
                        tabIndex={0}
                        label="Username"
                        value={username}/>
                    <TextField
                        className={classNames(classes.textField, 'verificationCode')}
                        label="Verification Code"
                        value={verificationCode}
                        inputProps={{ maxLength: 6 }}
                        onChange={(e) => this.setState({ verificationCode: e.target.value })}/>
                    <ValidatePasswordField
                        className={classNames(classes.validatePasswordField, 'new-password')}
                        label="New Password"
                        value={newPassword}
                        onChange={(e) => this.setState({ newPassword: e.target.value })}/>
                    <TextField
                        className={classNames(classes.textField, 'confirm-new-password')}
                        label="Confirm New Password"
                        value={confirmNewPassword}
                        onChange={(e) => this.setState({ confirmNewPassword: e.target.value })}/>
                    <br />
                    <Button
                        className={classes.changePasswordBtn}
                        disabled={!changePasswordBtnEnabled}
                        variant='contained'
                        id='set-password-submit'
                        type="submit"
                        color='primary'
                        onClick={() => { this.confirmPasswordChange() }}>
                        Change Password
                     </Button>
                    <Button size='small'
                        id='forgot-password-btn'
                        className={classes.underlineBtn} onClick={() => { this.props.done() }}>
                        Return to Login
                    </Button>
                </div>
            </div>
        )


    }
}

export default withStyles(styles)(ForgotPasswordForm);